import * as React from 'react';
import type { FieldFormProps } from '@helpcenter/field-types';
import type { FieldOption } from '@helpcenter/form-select';
import { FormAsyncMultiSelect } from '@helpcenter/form-select';
import type { WrappedComponentProps } from 'react-intl';
import { injectIntl } from 'react-intl';
import type { ValueType } from '@atlaskit/select';
import { toMultiSelectValue } from '@atlassian/help-center-common-util/select';
import i18n from './messages';

export type AssetsPickerOption = FieldOption<string>;

export interface Props extends FieldFormProps<string[]> {
	label: string;
	loadOptions: (inputValue: string, callback: (options: AssetsPickerOption[]) => void) => void;
	isLoading?: boolean;
	doInitialSearch?: boolean; // Whether we do an initial loadOptions("")
	isFieldConfigLoaded?: boolean;
	accountId: string | undefined;
}

export class AssetsPickerDumb extends React.Component<Props & WrappedComponentProps> {
	onChangeForMultiSelect = (options: ValueType<AssetsPickerOption>) => {
		this.props.onChange?.(
			this.props.id,
			toMultiSelectValue(options).map((v) => v.value),
		);
	};

	noOpt = (inputValues: { inputValue: string }) => {
		return inputValues.inputValue === ''
			? this.props.intl.formatMessage(i18n.typeToSearch)
			: this.props.intl.formatMessage(i18n.noOptions);
	};

	render() {
		const {
			disabled,
			doInitialSearch,
			intl,
			isLoading,
			isFieldConfigLoaded,
			accountId,
			...otherProps
		} = this.props;

		return (
			<FormAsyncMultiSelect
				{...otherProps}
				actionSubjectId="assetsPickerField"
				// We set a key on this component so that it re-mounts when the field configuration is loaded, or,
				// the account id changes. The re-mounting triggers the initial search, which is skipped when the
				// field configuration is not loaded.
				// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
				// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
				key={`asset-loaded-${isFieldConfigLoaded}-${accountId}`}
				placeholder={intl.formatMessage(i18n.searchPlaceholder)}
				noOptionsMessage={this.noOpt}
				isDisabled={disabled}
				isLoading={isLoading}
				onChange={this.onChangeForMultiSelect}
				defaultOptions={doInitialSearch}
			/>
		);
	}
}

export default injectIntl(AssetsPickerDumb);
